import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appreviewsCreateReviewRequest = {};
var _appreviewsCreateReviewResponse = { review: '_appreviewsReview' };
var _appreviewsGetReviewRequest = {};
var _appreviewsGetReviewResponse = { review: '_appreviewsReview' };
var _appreviewsReview = {
    createdAt: 'google.protobuf.Timestamp',
    modifiedAt: 'google.protobuf.Timestamp',
    publishedAt: 'google.protobuf.Timestamp',
    unpublishedAt: 'google.protobuf.Timestamp',
    replies: '_reply',
};
var _copyOpinionsRequest = {};
var _copyOpinionsResponse = {};
var _copyReviewsRequest = {};
var _copyReviewsResponse = {};
var _createOpinionRequest = {};
var _createOpinionResponse = { opinion: '_opinion' };
var _createReplyRequest = {};
var _createReplyResponse = { reply: '_reply' };
var _deleteOpinionRequest = {};
var _deleteOpinionResponse = { opinion: '_opinion' };
var _deleteReplyRequest = {};
var _deleteReplyResponse = {};
var _getAppReviewsRequest = {};
var _getAppReviewsResponse = {
    userReview: '_appreviewsReview',
    reviews: '_appreviewsReview',
};
var _getUserReviewRequest = {};
var _getUserReviewResponse = { userReview: '_appreviewsReview' };
var _opinion = { createdAt: 'google.protobuf.Timestamp' };
var _queryReviewsRequest = {};
var _queryReviewsResponse = { reviews: '_appreviewsReview' };
var _reply = {
    createdAt: 'google.protobuf.Timestamp',
    modifiedAt: 'google.protobuf.Timestamp',
};
var _updateReplyRequest = {};
var _updateReplyResponse = { reply: '_reply' };
var _updateReviewPublishedStatusRequest = {};
var _updateReviewPublishedStatusResponse = { review: '_appreviewsReview' };
var _updateReviewRequest = {};
var _updateReviewResponse = { review: '_appreviewsReview' };
function resolveComWixpressDevcenterAppreviewsReviewsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/app-reviews',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create a Review. */
export function appReviewsNamespaceCreateReview(payload) {
    var _a = serializer(_appreviewsCreateReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_appreviewsCreateReviewResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __appReviewsNamespaceCreateReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.CreateReview',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __appReviewsNamespaceCreateReview.fromReq = fromReq;
    return __appReviewsNamespaceCreateReview;
}
/** Get a Review. */
export function appReviewsNamespaceGetReview(payload) {
    var _a = serializer(_appreviewsGetReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_appreviewsGetReviewResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __appReviewsNamespaceGetReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.GetReview',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __appReviewsNamespaceGetReview.fromReq = fromReq;
    return __appReviewsNamespaceGetReview;
}
/** Deprecated, please use QueryReviews for the reviews and GetUserReview for the user review. */
export function getAppReviews(payload) {
    var _a = serializer(_getAppReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppReviewsResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __getAppReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.GetAppReviews',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/app',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppReviews.fromReq = fromReq;
    return __getAppReviews;
}
/** Get the review the user (in context) left for an app. */
export function getUserReview(payload) {
    var _a = serializer(_getUserReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserReviewResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __getUserReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.GetUserReview',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/user-review',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserReview.fromReq = fromReq;
    return __getUserReview;
}
export function queryReviews(payload) {
    var _a = serializer(_queryReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReviewsResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __queryReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.QueryReviews',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReviews.fromReq = fromReq;
    return __queryReviews;
}
/** Update a Review. */
export function updateReview(payload) {
    var _a = serializer(_updateReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReviewResponse, {
        _appreviewsReview: _appreviewsReview,
        _reply: _reply,
    }).fromJSON;
    function __updateReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'PUT',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.UpdateReview',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReview.fromReq = fromReq;
    return __updateReview;
}
/** Publish or Unpublish a Review. Only available to app market admins. */
export function updateReviewPublishedStatus(payload) {
    var _a = serializer(_updateReviewPublishedStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReviewPublishedStatusResponse, { _appreviewsReview: _appreviewsReview, _reply: _reply }).fromJSON;
    function __updateReviewPublishedStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'PUT',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.UpdateReviewPublishedStatus',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/published',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReviewPublishedStatus.fromReq = fromReq;
    return __updateReviewPublishedStatus;
}
/** Create a Reply to a Review. Only available to app team members. */
export function createReply(payload) {
    var _a = serializer(_createReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReplyResponse, { _reply: _reply }).fromJSON;
    function __createReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.CreateReply',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/replies',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReply.fromReq = fromReq;
    return __createReply;
}
/** Update a reply. Only available to app team members. */
export function updateReply(payload) {
    var _a = serializer(_updateReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReplyResponse, { _reply: _reply }).fromJSON;
    function __updateReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'PUT',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.UpdateReply',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/replies/{replyId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReply.fromReq = fromReq;
    return __updateReply;
}
/** Delete a reply. Only available to app team members. */
export function deleteReply(payload) {
    var _a = serializer(_deleteReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteReplyResponse, {}).fromJSON;
    function __deleteReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'DELETE',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.DeleteReply',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/replies/{replyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReply.fromReq = fromReq;
    return __deleteReply;
}
/** Create an Opinion for a Review. Only available to users. */
export function createOpinion(payload) {
    var _a = serializer(_createOpinionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOpinionResponse, {
        _opinion: _opinion,
    }).fromJSON;
    function __createOpinion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.CreateOpinion',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/opinion',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOpinion.fromReq = fromReq;
    return __createOpinion;
}
/** Delete an Opinion for a Review. */
export function deleteOpinion(payload) {
    var _a = serializer(_deleteOpinionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteOpinionResponse, {
        _opinion: _opinion,
    }).fromJSON;
    function __deleteOpinion(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'DELETE',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.DeleteOpinion',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/{reviewId}/opinion/{opinionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteOpinion.fromReq = fromReq;
    return __deleteOpinion;
}
export function copyReviews(payload) {
    var _a = serializer(_copyReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_copyReviewsResponse, {}).fromJSON;
    function __copyReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.CopyReviews',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __copyReviews.fromReq = fromReq;
    return __copyReviews;
}
export function copyOpinions(payload) {
    var _a = serializer(_copyOpinionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_copyOpinionsResponse, {}).fromJSON;
    function __copyOpinions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.appreviews.ReviewsService.CopyOpinions',
            url: resolveComWixpressDevcenterAppreviewsReviewsServiceUrl({
                protoPath: '/v1/reviews/copy/opinions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __copyOpinions.fromReq = fromReq;
    return __copyOpinions;
}
//# sourceMappingURL=http.impl.js.map